import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {featureKeyAuth} from './feature-auth.selectors';
import {featureAuthReducer} from './feature-auth.reducer';
import {EffectsModule} from '@ngrx/effects';
import {FeatureAuthEffects} from './feature-auth.effects';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(featureKeyAuth, featureAuthReducer),
    EffectsModule.forFeature([FeatureAuthEffects]),
  ],
})
export class FeatureAuthModule {
}
